module.exports = __webpack_public_path__ + "img/workBench1.9b04a2b2.png";